import React from 'react'
import { Route, Switch } from 'react-router-dom'

import Home from './nutrition/Home'
import Dietary from './nutrition/Dietary'
import Tips from './nutrition/Tips'
import AntiInflammatory from './nutrition/AntiInflammatory'
import Snacks from './nutrition/Snacks'


const NutritionPage = ({ match }) => {
    return (
        <Switch>
            <Route exact path={`${match.url}`} component={Home} />
            <Route exact path={`${match.url}/dietary`} component={Dietary} />
            <Route exact path={`${match.url}/tips`} component={Tips} />
            <Route exact path={`${match.url}/anti-inflammatory`} component={AntiInflammatory} />
            <Route exact path={`${match.url}/snacks`} component={Snacks} />


        </Switch>
    )
}

export default NutritionPage
